// Major
import React from "react";

// Components
import MKBox from "components/MKBox";
import PageHeader from "components/CBPageHeader";
import { StyledSectionBackgroundWrapper } from "index.styles";
import GhlFormEmbed from "components/GhlFormEmbed";
// import PageHeader from "../pageHeader";

const CandidateSurveyForm = () => {
  return (
    <MKBox>
      <StyledSectionBackgroundWrapper>
        <PageHeader
          headerType="default"
          header="Interested in \n better health?"
          headerAccent={["Interested in"]}
          headerTagline="Please take a moment to answer a few questions to see if our program might be right for you."
          lightText="true"
        />
      </StyledSectionBackgroundWrapper>
      <GhlFormEmbed
        formId="MpxWT5ItLJCpXUfYyv3D"
        formType="survey"
        title="Online Self Assessment"
        height="600px"
        style={{ minHeight: "600px" }}
      />
    </MKBox>
  );
};

export default CandidateSurveyForm;
